import React,{useEffect, useState} from 'react'
import FmsDashboardMainRoot from '../FmsDashboardMainRoot'
import { useLocation, useNavigate, } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import TextArea from 'antd/lib/input/TextArea';
import { SmallText } from '../../../helpers/constants/ConstantsText';
import { Button, Input } from 'antd';
import {AiOutlineInfoCircle} from 'react-icons/ai'
import {Select} from 'antd'
import PrimaryButton, { SecondaryButton } from '../../../components/buttons/PrimaryButton';
import axios from 'axios';
import { authHeader } from '../../../helpers/usertoken/UserToken';
import { base_url } from '../../../App';
import { useSelector } from 'react-redux';
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'


function FMSSalaryAdvanceRequestCE() {
  

  const {state} = useLocation()
  const roles = useSelector(state => state.Auth.roles)



  const navigate = useNavigate()
  const statusArr = [{label:'Pending',value:'Pending'},{label:'Approved',value:'Approved'},{label:'Rejected',value:'Rejected'}]
  const [data,setdata] = useState({employee:'',requested_by:'',approved_by:'',amount:'',status:'',remarks:'',hr_remarks:'',finance_remarks:'',finance_approved:false})
  const [error,seterror] = useState({employee:'',requested_by:'',approved_by:'',amount:'',status:'',remarks:'',hr_remarks:'',finance_remarks:'',finance_approved:''})


  let disabled = roles?.includes('fms_user')

  useEffect(()=>{

    let passData = {
      ...state,
      employee:{label:state?.employee?.name,value:state?.employee?._id},
      requested_by:state?.requested_by?._id !== undefined ?  {label:state?.requested_by?.name,value:state?.requested_by?._id} : '',
      approved_by:state?.approved_by?._id !== undefined ? {label:state?.approved_by?.name,value:state?.approved_by?._id} : '',
      finance_approved_by:state?.finance_approved_by?._id !== undefined ? {label:state?.finance_approved_by?.name,value:state?.finance_approved_by?._id} : ''
    }
    setdata(passData)


  },[state])

  function submitformfun(){

    if(!data.employee?._id){
      seterror({...error,employee:'This Field is required!'})
    }if(!data.amount){
      seterror({...error,amount:'This Field is required!'})
    }else if(!data.remarks){
      seterror({...error,remarks:'This Field is required!'})
    }else{
      let send_data = {
        ...data
      }
      send_data['employee'] = data?.employee?.value
      send_data['requested_by'] = data?.requested_by?.value
      
      if(send_data?.approved_by?.value !== undefined){
        send_data['approved_by'] = data?.approved_by?.value
      }else{
        delete send_data.approved_by
      }

      if(send_data?.finance_approved_by?.value !== undefined){
        send_data['finance_approved_by'] = data?.finance_approved_by?.value
      }else{
        delete send_data.finance_approved_by
      }

      authHeader['headers']['Content-Type'] = 'application/json'

      axios.put(`fms/salary_advance/update/${data._id}`,send_data,authHeader)
        .then((res)=>{
            console.log("res?.data",res?.data)
            toast.success("Update Successfully!!");
            resetform();
        }).catch((err)=>{
            if(err?.response?.status == 403){
                toast.error(err?.response?.data?.message)
            }
        })
    }

  }


  function resetform(){
    navigate(-1)
    setdata({info:'',attachment:'',pdf_file:'',incident_title:'',summary:'',fms_employee:'',status:'',finance_remarks:'',finance_approved:false})
    seterror({info:'',attachment:'',pdf_file:'',incident_title:'',summary:'',fms_employee:'',status:'',finance_remarks:'',finance_approved:''})
  }


  function uploadFile(v){
    authHeader['headers']['Content-Type'] = 'multipart/form-data'
    var fd = new FormData()
    fd.append('file',v?.fileList[v?.fileList.length - 1]?.originFileObj)
    axios.post(`fms/warning_letter/upload_file`,fd,authHeader)
    .then((res)=>{
      setdata({...data,pdf_file:res?.data?.data})
      seterror({...error,pdf_file:''})
    }).catch((err)=>{
        console.log("err data",err)
    })
  }

  function openfile(v){
      let url = `${base_url}${v}`
      window.open(url,'_blank')
   }

  return (
    <FmsDashboardMainRoot>
      <Toaster />
       <div style={{width:'25%'}}>
       <h6>Salary Advance Request</h6>
       <h6 style={{fontSize:'10px',background:'#3d7aba',fontWeight:'600',color:'#fff',padding:6}}>Use the below form to create or update the salary advance request of an onboarded employee</h6>
         
         

        <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'Onboarded Employee'}  />
            </div>
            <Input type="text"  style={{borderLeft:'4px solid #292961',}}  value={data?.employee?.label}  />
        </div>
        <div style={{display:'flex'}}>
            {(error?.employee) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.employee}</p>
        </div>


        <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'Requested By'}  />
            </div>
            <Input type="text"  style={{borderLeft:'4px solid #292961',}}  value={data?.requested_by?.label}  />
        </div>
        <div style={{display:'flex'}}>
            {(error?.requested_by) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.requested_by}</p>
        </div>

        {/* <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'Approved By'}  />
            </div>
            <Input type="text"  style={{borderLeft:'4px solid #292961',}}  value={data?.approved_by?.label}  />
        </div>
        <div style={{display:'flex'}}>
            {(error?.approved_by) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.approved_by}</p>
        </div> */}

        <>
        <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'Amount'}  />
            </div>
            <Input type="text"  style={{borderLeft:'4px solid #292961',}}  value={data.amount} onChange={(e)=>{setdata({...data,amount:e.target.value});seterror({...error,amount:''})}} />
        </div>
        <div style={{display:'flex'}}>
            {(error?.amount) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.amount}</p>
        </div>

        <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'Remarks'}  />
            </div>
            <TextArea type="text"  style={{borderLeft:'4px solid #292961',}}  value={data.remarks} onChange={(e)=>{setdata({...data,remarks:e.target.value});seterror({...error,remarks:''})}} />
        </div>
        <div style={{display:'flex'}}>
            {(error?.remarks) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.remarks}</p>
        </div>

        <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'HR Remarks'}  />
            </div>
            <TextArea type="text"  style={{borderLeft:'4px solid #292961',}}  value={data.hr_remarks} onChange={(e)=>{setdata({...data,hr_remarks:e.target.value});seterror({...error,hr_remarks:''})}} />
        </div>
        <div style={{display:'flex'}}>
            {(error?.hr_remarks) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.hr_remarks}</p>
        </div>

        <div style={{marginTop:'10px'}}>
        <SmallText fontWeight={'600'} val={'Status'}  />
        </div>
        <div  style={{margin:'0px 0px 10px 0px',zIndex:200,borderLeft:'4px solid #292961',}}>
          <Select 
            disabled={disabled}
            filterOption={false}
            style={{ width: '100%',boxShadow:'none' }}
            value={data?.status === '' ? null : data?.status}
            options={statusArr}
            onChange={(v)=>{setdata({...data,status:v});seterror({...error,status:''})}}
          />
        </div>

        {(roles?.includes('fms_finance') || roles?.includes('admin')) && <>
          <div style={{display:'flex',alignItems:'center'}}>
              {!data?.finance_approved ? 
              <BiCheckbox onClick={()=>setdata({...data,finance_approved:!data?.finance_approved})} size={24} style={{color:'#ddd',marginLeft:'0px'}} /> :
              <BiCheckboxSquare onClick={()=>setdata({...data,finance_approved:!data?.finance_approved})} size={24} style={{color:'#587487',marginLeft:'0px'}}  />}
              <h6 style={{fontSize:'11px',fontWeight:'800',marginTop:'5px'}}>Finance Approved</h6>
          </div>


          <div style={{marginBottom:'10px'}}>
            <div style={{width:'150px',marginTop:'10px'}}>
            <SmallText fontWeight={'600'} val={'Finance Remarks'}  />
            </div>
            <TextArea type="text"  value={data.finance_remarks} onChange={(e)=>{setdata({...data,finance_remarks:e.target.value});seterror({...error,finance_remarks:''})}} />
        </div>
        <div style={{display:'flex'}}>
            {(error?.finance_remarks) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
            <p style={{marginBottom:'0px',fontSize:'10px',color:'red',paddingLeft:'3px'}}>{error?.finance_remarks}</p>
        </div>
        </>}

        </>

       



        <div style={{marginLeft:'0px',display:'flex',width:'100px',justifyContent:'space-between'}}>
          <PrimaryButton btn_name="Submit"  onClick={()=>submitformfun()}/>
          <SecondaryButton btn_name={"Clear"} onClick={()=>{resetform()}} />
        </div>
          



       </div>
    </FmsDashboardMainRoot>
  )
}

export default FMSSalaryAdvanceRequestCE